<div>
    <nav class="navbar navbar-expand-lg navbar-expand-md sticky-top navbar-expand-sm p-3 m-2">
        <div class="navbar-list m-auto">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item align-name mr-3">
                <a class="navbar-brand">
                    <img class="align-image ml-3" alt="Fluidra logo" src="assets/img/fluidra_pool_logo.svg">
                </a>
            </li>
            <li class="nav-item" id="fluidraProLogo">
                <a class="navbar-brand">
                    <img class="align-image ml-4 mt-2" id="fluidraPro" alt="Fluidra logo" src="assets/img/FluidraPro_Logo_Blue 3.svg">
                </a>
            </li>
          </ul>
        </div>
    </nav>
    
    <div class="bg_login" style="background-size: cover !important"></div>
    <div class="content_login justify-content-center">
      <div class="col-12 col-sm-10 col-md-7 col-lg-6 col-xl-5 rounded m-2 text-center">
            
            <div class="box mb-3">
                <h2>{{'lang.welcome1' | translate}}</h2>
                <h2 class="welcom2 m-1 mb-4">{{'lang.welcome2' | translate}}</h2>
                <button type="button"class="btn signin-btn btn-signin p-2" (click)="callGsuiteLogin()">{{'lang.sign_in' |
                    translate}}</button>
                <p class="troublemsg mt-5 mb-n1">{{'lang.trouble_msg' | translate}}</p>
            </div>
      </div>
    </div>
</div>
